import { UNAUTHORIZED_EVENT } from "api/constants";
import { getTabToken } from "common/MetaActions";
import { useRootStore } from "store";

export type UploadErrorContext = {
  setFailedWrapper: (isFailed: boolean, message: string) => boolean;
};

export type EmptyFoldersErrorContext = {
  showWarning: boolean;
};

export const uploadErrorHandler: <T>(err: any, context: T) => boolean = (
  err,
  context
) => {
  try {
    const errors = err?.response?.body?.errors;
    const { setFailedWrapper } = context as UploadErrorContext;

    if (errors && typeof errors === "object") {
      Object.keys(errors).forEach((key) => {
        setFailedWrapper(true, (errors as any)[key][0]);
      });

      return true;
    }

    return false;
  } catch (parseError) {
    console.error("Failed to parse error response:", parseError);
    return false;
  }
};

export const threadRedirectOn404Handler: <T>(err: any, context?: T) => boolean = (err) => {
  const status = err?.status || err?.response?.status;
  if (status === 404) {
    const token = getTabToken();
    if (token && window.location.pathname !== "/unauthorized") {
      window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT, { detail: { status } }));
    }
    return true;
  }
  return false;
};

export const emptyFoldersErrorHandler: <T>(err: any, context: T) => boolean = (
  err,
  context
) => {
  let statusCode: number | undefined;

  const { showWarning } = context as EmptyFoldersErrorContext;

  if (err && typeof err === "object" && "status" in err) {
    statusCode = (err as { status: number }).status;
  }
  if (statusCode === 404) {
    if (showWarning) {
      const { error } = useRootStore.getState();
      error.handleCustomWarningMessage(
        statusCode,
        "Dokumentarkivet innehåller inga mappar."
      );
    }
    return true;
  }
  return false;
};
